import React, { Fragment } from 'react';
import { Link } from '../commonComponents';
import Image from '../commonComponents/image/Image';
import { language, LANG_RU, LANG_ARABIA_EN, LANG_ARABIA } from 'Root/constants';
import { share, insta, twitter, youtube, whatsapp, vk } from '../../assets/imgs/newUi/header/index';

import {FBButton, InstaButton, TwitterButton, WhatsappButton, VKButton, TelegramButton } from '../commonComponents/shareButton/ShareButton'


const SubItem = () => {

  const title = `${document.title}`;
  const url = process.env.REACT_APP_SHARE_URL;



  return (
    <div className="sub-menu">
      <ul>
        <li>
          <FBButton url={url} title={title} shareimg={share} />
        </li>
        {/* {language===LANG_RU &&
        <li>
          <InstaButton url={url} title={title} shareimg={insta} />
        </li>
        } */}
        {(language===LANG_ARABIA_EN || language===LANG_ARABIA) &&
        <li>
          <TwitterButton url={url} title={title} shareimg={twitter} />
        </li>
        }
        <li>
          <WhatsappButton url={url} title={title} shareimg={whatsapp} />
        </li>
        {language===LANG_RU &&
        <li>
          <VKButton url={url} title={title} shareimg={vk} />
        </li>}        
      </ul>
    </div>
  );
};

export default SubItem;